
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import axios from '../Axiosinstance';
import {
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Container,
    Button,
    MenuItem,
    Select,
    TextField,
    Box,
    TablePagination, Card, CardContent,
    Paper,
    Dialog, DialogTitle, FormControl, InputLabel, Typography, Grid, DialogContentText
} from '@mui/material';
import { CLOUDINARY_UPLOAD_PRESET, baseURL } from '../common'
import dayjs from 'dayjs';

// import { Button, Modal, Spinner } from 'react-bootstrap';

import { toast, ToastContainer } from 'react-toastify';



const ViewDetailsModal = ({ editForm, onAction }) => {



    const [isFocused, setIsFocused] = useState(false);

    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [editFormData, setEditFormData] = useState(editForm);
    const [selectedFile, setSelectedFile] = useState(null);
    const [nricdoc, setNricdoc] = useState(null);
    const [educationdoc, setEducationaldoc] = useState(null);
    const [passportdoc, setPassportdoc] = useState(null);
    const [initialDate, setInitialDate] = useState(editForm.enrolledDate);
    const [initialModulus, setInitialModulus] = useState(editForm.startModulus)
    const [batches, setBatches] = useState([]);
    const [selectedBatchesData, setSelectedBatchesData] = useState(editForm.batch);
    const [errors, setErrors] = useState({});


    const [uploadedPreviews, setUploadedPreviews] = useState({
        profileUrl: editForm.profileUrl || '',
        nricdoc: editForm.nricdoc || '', // Correct key names
        educationdoc: editForm.educationdoc || '',
        passportdoc: editForm.passportdoc || '',
    });
    // const [uploadedImageUrl, setUploadedImageUrl] = useState('');

    // const [formData, setFormData] = useState({
    //     fullname: '',
    // });

    const CLOUDINARY_URL = baseURL;
    const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;

    const handleChange = (event) => {
        const { name, value } = event.target;

        if (name === "course") {
            // Find the selected batch details
            const selectedBatch = batches.find((batch) => batch.course === value);
            setSelectedBatchesData(selectedBatch);
            // console.log("selectedBatch", selectedBatch);
            const currentDate = new Date();
            const newModulus = handleDateChangeForCourse(selectedBatch, currentDate);
            // Update editFormData with course, batchId, and startModulus
            setEditFormData((prevData) => ({
                ...prevData,
                course: value, // Selected course name
                batchId: selectedBatch?.id || null, // Selected batchId
                startModulus: newModulus || null, // Selected currentModule
                batch: selectedBatch || null,
            }));
        } else {
            // For other fields, update the state normally
            setEditFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleNricEmailChange = async (e) => {
        const { name, value } = e.target;
        const formattedValue = value.toUpperCase().trim(); // Convert to uppercase & remove spaces
        const nricRegex = /^[STFGM]\d{7}[A-Z]$/i; // NRIC format (case-insensitive)

        // Update form state
        setEditFormData((prev) => ({ ...prev, [name]: formattedValue }));

        // Check if NRIC is valid
        if (name === "nric" && !nricRegex.test(formattedValue)) {
            setErrors((prev) => ({ ...prev, nric: "Invalid NRIC format (e.g., A1234567Z)" }));
            return; // Stop API request if invalid NRIC
        } else {
            setErrors((prev) => ({ ...prev, nric: "" })); // Clear error if valid
        }

        // API Call Only If Value Is Not Empty
        if (formattedValue !== "") {
            try {
                const response = await axios.get(`/registrationadvances/exists?${name}=${formattedValue}`);

                if (response.data) {
                    setErrors((prev) => ({ ...prev, [name]: `${name.toUpperCase()} already exists!` }));
                } else {
                    setErrors((prev) => ({ ...prev, [name]: "" }));
                }
            } catch (error) {
                console.error(`Error checking ${name}:`, error);
                setErrors((prev) => ({ ...prev, [name]: `Error checking ${name}. Try again!` }));
            }
        }
    };



    // console.log("ff", editFormData);

    const handleSaveEdit = async (e) => {
        e.preventDefault();

        try {
            // Validate required fields
            const requiredFields = ['name', 'email', 'phone', 'nric', 'passport', 'passportExpiryDate', 'enrolledDate', 'course', 'password', 'religion', 'citizenship', 'address',];
            const emptyFields = requiredFields.filter(
                (field) => !editFormData[field] || editFormData[field].trim() === ''
            );

            if (emptyFields.length > 0) {
                toast.error(`The following fields are required: ${emptyFields.join(', ')}`);
                return;
            }

            let imageUrl = uploadedPreviews.profileUrl;
            let nricdocUrl = uploadedPreviews.nricdoc;
            let educationaldocUrl = uploadedPreviews.educationdoc;
            let passportdocUrl = uploadedPreviews.passportdoc;

            // Cloudinary upload function
            const uploadToCloudinary = async (file, path) => {
                const timestamp = Date.now();
                const fileExtension = file.name.split('.').pop();
                const fileNameWithTimestamp = `${timestamp}.${fileExtension}`;

                const formDataWithImage = new FormData();
                formDataWithImage.append('file', file, fileNameWithTimestamp);
                formDataWithImage.append('upload_preset', CLOUDINARY_UPLOAD);
                formDataWithImage.append('public_id', `LMS/Student/${path}/${fileNameWithTimestamp}`);

                const imageResponse = await fetch(CLOUDINARY_URL, {
                    method: 'POST',
                    body: formDataWithImage,
                });

                const imageData = await imageResponse.json();
                if (!imageResponse.ok || !imageData.secure_url) {
                    throw new Error(`Failed to upload file: ${file.name}`);
                }
                return imageData.secure_url;
            };

            // Upload files if selected
            if (selectedFile) imageUrl = await uploadToCloudinary(selectedFile, 'Profile');
            if (nricdoc) nricdocUrl = await uploadToCloudinary(nricdoc, 'NRIC');
            if (educationdoc) educationaldocUrl = await uploadToCloudinary(educationdoc, 'EducationalDocs');
            if (passportdoc) passportdocUrl = await uploadToCloudinary(passportdoc, 'PassportDocs');

            // Prepare updated student object
            const updatedStudent = {
                ...editFormData,
                profileUrl: imageUrl,
                nricdoc: nricdocUrl,
                educationdoc: educationaldocUrl,
                passportdoc: passportdocUrl,
            };

            // API request
            const response = await axios.put(
                `/registrationadvances/${editFormData.id}`,
                updatedStudent
            );

            if (response.status === 200) {
                toast.success('Student updated successfully');
                onAction();
            } else {
                throw new Error('Failed to update student.');
            }
        } catch (error) {
            console.error('Error updating student:', error);
            toast.error('An error occurred while updating the student. Please try again.');
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];
        const fileUrl = URL.createObjectURL(file);

        switch (name) {
            case 'profile':
                setSelectedFile(file);
                setUploadedPreviews((prev) => ({ ...prev, profileUrl: fileUrl }));
                break;
            case 'nric':
                setNricdoc(file);
                setUploadedPreviews((prev) => ({ ...prev, nricdoc: fileUrl }));
                break;
            case 'educational':
                setEducationaldoc(file);
                setUploadedPreviews((prev) => ({ ...prev, educationdoc: fileUrl }));
                break;
            case 'passport':
                setPassportdoc(file);
                setUploadedPreviews((prev) => ({ ...prev, passportdoc: fileUrl }));
                break;
            default:
                break;
        }
    };

    const handleInstitutionChange = (index, e) => {
        const { name, value } = e.target;

        const newInstitutionDetails = editFormData.institutionDetails.map((institution, i) => {
            if (i === index) {
                const updatedInstitution = { ...institution, [name]: value };

                const fromYear = parseInt(updatedInstitution.fromYear);
                const toYear = parseInt(updatedInstitution.toYear);

                // Validate only if both years have 4 digits
                if (
                    !isNaN(fromYear) &&
                    !isNaN(toYear) &&
                    updatedInstitution.fromYear.length === 4 &&
                    updatedInstitution.toYear.length === 4
                ) {
                    if (fromYear > toYear) {
                        toast.error("From Year cannot be greater than To Year");
                    }
                }

                return updatedInstitution;
            }
            return institution;
        });

        setEditFormData({ ...editFormData, institutionDetails: newInstitutionDetails });
    };


    const handleAddEducation = () => {
        setEditFormData({
            ...editFormData,
            institutionDetails: [
                ...editFormData.institutionDetails,
                { institution: '', year: '', qualificationsAchieved: '' },
            ],
        });
    };

    const handleRemoveEducation = (index) => {
        const newInstitutionDetails = editFormData.institutionDetails.filter((_, i) => i !== index);
        setEditFormData({ ...editFormData, institutionDetails: newInstitutionDetails });
    };


    const handleWorkExperienceChange = (index, e) => {
        const { name, value } = e.target;

        const newWorkExperiences = editFormData.workExpirences.map((experience, i) => {
            if (i === index) {
                const updatedExperience = { ...experience, [name]: value };

                const fromYear = parseInt(updatedExperience.fromYear);
                const toYear = parseInt(updatedExperience.toYear);

                // Validate only if both years have 4 digits
                if (
                    !isNaN(fromYear) &&
                    !isNaN(toYear) &&
                    updatedExperience.fromYear.length === 4 &&
                    updatedExperience.toYear.length === 4
                ) {
                    if (fromYear > toYear) {
                        toast.error("From Year cannot be greater than To Year in Work Experience");
                    }
                }

                return updatedExperience;
            }
            return experience;
        });

        setEditFormData({
            ...editFormData,
            workExpirences: newWorkExperiences
        });
    };

    const handleAddWorkExperience = () => {
        setEditFormData((prevState) => ({
            ...prevState,
            workExpirences: [
                ...prevState.workExpirences,
                { name: '', position: '', year: '' }
            ]
        }));
    };

    const handleRemoveWorkExperience = (index) => {
        const newWorkExperiences = editFormData.workExpirences.filter((_, i) => i !== index);
        setEditFormData({
            ...editFormData,
            workExpirences: newWorkExperiences
        });
        if (newWorkExperiences.length === 0) {
            //   setShowEmploymentFields(false); // Hide employment fields if no experience entries
        }
    };


    const moduleDetailsMap = {};
    editFormData.batch?.moduleDetails.forEach((module) => {
        moduleDetailsMap[module.id] = module.moduleName;
    });

    const dayMapping = {
        'Sunday': 0,
        'Monday': 1,
        'Tuesday': 2,
        'Wednesday': 3,
        'Thursday': 4,
        'Friday': 5,
        'Saturday': 6
    };

    //for enrollment date edit
    const handleDateChange = (event) => {

        const selectedBatch = batches.find((batch) => batch.id === selectedBatchesData.id);
        // setSelectedBatchesData(selectedBatch);
        console.log(selectedBatch?.status);

        const { value } = event.target;
        const newDate = dayjs(value);
        const oldDate = dayjs(editFormData.enrolledDate);

        const intakeStartDate = selectedBatch?.intakeStartDate ? dayjs(selectedBatch.intakeStartDate) : null;
        const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);


        if (selectedBatch?.status && newDate.isBefore(oldDate, 'day') && intakeStartDate) {
            // toast.error("Enrollment date cannot be before today.");
            alert("Enrollment date cannot be before today.")
            return;
        } else if (selectedBatch?.status && isDatePassed) {
            alert("Batch is not started yet.");
            return;
        } else if (selectedBatch?.status && !isDatePassed) {
            console.log("Batch is active. Using current module:", selectedBatch?.currentModule);
            setEditFormData((prev) => ({
                ...prev,
                enrolledDate: value,
                startModulus: selectedBatch.currentModule,
                offerDate: value
            }));
            return;
        }


        const firstDay = editFormData.batch.days[0];
        const dayIndex = dayMapping[firstDay.day];

        // Helper to find the first Sunday of the month
        const getFirstSunday = (date) => {
            let firstSunday = date.startOf('month');
            while (firstSunday.day() !== dayIndex) { // 0 is Sunday in Day.js
                firstSunday = firstSunday.add(1, 'day');
            }
            return firstSunday;
        };

        // Determine the effective month (current or next based on first Sunday)
        const getEffectiveMonth = (date) => {
            const firstSunday = getFirstSunday(date);
            return date.isAfter(firstSunday)
                ? date.add(1, 'month').startOf('month')
                : date.startOf('month');
        };

        // Calculate effective months for both dates
        const oldEffective = getEffectiveMonth(oldDate);
        const newEffective = getEffectiveMonth(newDate);

        // Month difference between effective months
        const deltaMonths = newEffective.diff(oldEffective, 'month');

        // Calculate new modulus (1-12)
        let newModulus = editFormData.startModulus + deltaMonths;
        newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1; // Ensure 1-12

        // Update state
        setEditFormData((prev) => ({
            ...prev,
            enrolledDate: value,
            startModulus: newModulus,
            offerDate: value
        }));
    };

    //if course changes need new startmodulus 
    const handleDateChangeForCourse = (batch, currentDate) => {
        // Get the new date from the event
        //    const { value } = event.target;
        //    console.log("Selected Enrollment Date:", value);

        const newDate = dayjs(currentDate); // Create dayjs object from the new date
        const oldDate = dayjs(); // Get the current date

        console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
        console.log("New Date:", newDate.format('YYYY-MM-DD'));

        // Calculate the difference in months between the old and new dates
        let monthDifference = newDate.month() - oldDate.month();
        if (newDate.year() !== oldDate.year()) {
            monthDifference += (newDate.year() - oldDate.year()) * 12;
        }
        console.log("Month Difference:", monthDifference);

        // For advance diploma, the increment is simply the month difference
        let increment = monthDifference;
        console.log("Advance Diploma Course - Increment:", increment);

        // Calculate the new modulus value based on the increment
        let newModulus = batch.currentModule + increment;
        // Wrap around to keep it between 1 and 12 (instead of 1 and 6)
        newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;
        console.log("New Modulus Before Ensuring Range:", newModulus);

        const firstDay = batch.days[0]; // Assuming days is in the correct scope
        console.log("First Day from Data:", firstDay.day);

        const dayIndex = dayMapping[firstDay.day];
        // Determine the first occurrence of the specified day of the month
        const firstOfMonth = newDate.date(1); // Set to the first of the month
        let firstSpecifiedDay = firstOfMonth.day(dayIndex); // Find the first occurrence

        // If the first occurrence is in the previous month, move to the next week
        if (firstSpecifiedDay.isBefore(firstOfMonth)) {
            firstSpecifiedDay = firstSpecifiedDay.add(1, 'week');
        }

        console.log("First Specified Day of the Month:", firstSpecifiedDay.format('YYYY-MM-DD'));

        // Adjust modulus: if the enrollment date is after the first specified day,
        // add 1 to the new modulus.
        if (newDate.isAfter(firstSpecifiedDay)) {
            newModulus += 1;
            console.log("Adjusting Modulus by adding 1.");
        }

        // Ensure modulus value stays within the 1-12 range after adjustments
        newModulus = ((newModulus - 1) % 12 + 12) % 12 + 1;


        console.log("newModulus", newModulus)
        return newModulus;

    };


    const closeEditModal = () => {
        setEditModalOpen(false);
    };

    useEffect(() => {
        const fetchBatches = async () => {
            try {
                const response = await axios.get("batch-summary"); // API endpoint to get batches
                setBatches(response.data);
            } catch (error) {
                console.error("Error fetching batches:", error);
            }
        };

        fetchBatches();
    }, []);


    return (
        <Container component="main" maxWidth="lg">

            <Paper elevation={3} style={{ padding: '24px', borderRadius: '8px', maxWidth: '1400px', margin: '62px' }}>

                <Typography
                    variant="h4"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                        color: "primary.main",
                        textDecoration: "underline",
                        textUnderlineOffset: "6px",
                        letterSpacing: "1px",
                        textAlign: "center",
                        mt: 3,
                        mb: 4,
                        fontSize: "2rem",
                    }}
                >
                    NEW STUDENT FORM
                </Typography>
                <form onSubmit={handleSaveEdit}>
                    <Grid container spacing={3} >
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="FullName*"
                                name="name"
                                type='text'
                                onChange={handleChange}
                                value={editFormData.name}
                                fullWidth
                                margin="normal"

                            />
                        </Grid>
                        {/* 
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="proofType*"
                                name="proofType"
                                type='text'
                                onChange={handleChange}
                                value={editFormData.proofType}
                                fullWidth
                                margin="normal"

                            />
                        </Grid> */}

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel id="proofType-label">proof Type</InputLabel>
                                <Select
                                    labelId="proofType-label"
                                    id="proofType"
                                    name="proofType"
                                    value={editFormData.proofType || ""}
                                    onChange={handleChange}
                                    label="proof Type"
                                >
                                    <MenuItem value="">Select proof Type</MenuItem>
                                    <MenuItem value="NRIC"> NRIC</MenuItem>
                                    <MenuItem value="FIN"> FIN</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Email*"
                                name="email"
                                value={editFormData.email}
                                onChange={handleNricEmailChange}
                                fullWidth
                                margin="normal"
                            />
                            {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="NRIC*"
                                name="nric"
                                value={editFormData.nric}
                                onInput={(e) => {
                                    e.target.value = e.target.value.slice(0, 9);

                                }}
                                onChange={handleNricEmailChange}
                                fullWidth
                                margin="normal"
                            />
                            {errors.nric && <p style={{ color: "red" }}>{errors.nric}</p>}
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Passport*"
                                name="passport"
                                value={editFormData.passport}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                // type="date"
                                label="Passport Expiry Date*"
                                name="passportExpiryDate"
                                value={editFormData.passportExpiryDate}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                required
                                style={{ minWidth: 120 }}
                            >
                                <InputLabel id="course-label">Course</InputLabel>
                                <Select
                                    labelId="course-label"
                                    id="course"
                                    name="course"
                                    value={editFormData.course}
                                    onChange={handleChange}
                                    label="Course*"
                                >
                                    <MenuItem value="">
                                        <em>Select Course...</em>
                                    </MenuItem>
                                    {batches.map((batch) => (
                                        <MenuItem key={batch.id} value={batch.course}>
                                            {batch.course}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>


                        <Grid item xs={12} sm={6}>
                            <TextField
                                type='number'
                                label="Course Fee*"
                                name="courseFee"
                                value={editFormData.courseFee}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />

                        </Grid>


                        <Grid item xs={12} sm={6}>
                            <TextField
                                type='number'
                                label="Home Phone*"
                                name="phone"
                                value={editFormData.phone}
                                onChange={handleChange}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                }}

                                fullWidth
                                margin="normal"
                            />

                        </Grid>


                        {/* <Grid item xs={12} sm={6}>
                            <TextField
                                type='text'
                                label="Student ID*"
                                name="customId"
                                value={editFormData.customId}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />

                        </Grid> */}

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel id="durationType-label">Duration Type</InputLabel>
                                <Select
                                    labelId="durationType-label"
                                    id="durationType"
                                    name="durationType"
                                    value={editFormData.durationType || ""}
                                    onChange={handleChange}
                                    label="Duration Type"
                                >
                                    <MenuItem value="">Select Duration Type</MenuItem>
                                    <MenuItem value="part_time">Part Time</MenuItem>
                                    <MenuItem value="full_time">Full Time</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>


                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel id="maritalStatus-label">Marital Status</InputLabel>
                                <Select
                                    labelId="maritalStatus-label"
                                    id="maritalStatus"
                                    name="martialStatus"
                                    value={editFormData.martialStatus || ""}
                                    onChange={handleChange}
                                    label="Marital Status"
                                >
                                    <MenuItem value="">Select Marital Status</MenuItem>
                                    <MenuItem value="single">Single</MenuItem>
                                    <MenuItem value="married">Married</MenuItem>
                                    <MenuItem value="divorced">Divorced</MenuItem>
                                    <MenuItem value="widowed">Widowed</MenuItem>
                                </Select>
                                {/* {errors.maritalStatus && <p style={{ color: "red" }}>{errors.maritalStatus}</p>} */}
                            </FormControl>
                        </Grid>



                        {/* <Grid item xs={12} sm={6}>
                            <TextField
                                label="Document Date*"
                                name="offerDate"
                                value={editFormData.offerDate}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />

                        </Grid> */}
                        <Grid item xs={12} sm={6}>
                            <TextField
                                type='number'
                                label="Office Phone*"
                                name="officephone"
                                value={editFormData.officephone}
                                onChange={handleChange}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                }}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel id="gender-label">Gender*</InputLabel>
                                <Select
                                    labelId="gender-label"
                                    id="gender"
                                    name="gender"
                                    value={editFormData.gender}
                                    onChange={handleChange}
                                    label="Gender*"
                                >
                                    <MenuItem value="">Select Gender</MenuItem>
                                    <MenuItem value="Male">Male</MenuItem>
                                    <MenuItem value="Female">Female</MenuItem>
                                    <MenuItem value="Other">Other</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                type="date"
                                label="Date of Birth*"
                                name="dob"
                                value={editFormData.dob}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                type="date"
                                label="Enrolled Date*"
                                name="enrolledDate"
                                value={editFormData.enrolledDate}
                                onChange={handleDateChange}
                                fullWidth
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <br />
                            <div className="form-group">
                                {/* <label>Start Module*</label> */}
                                {/* <input
                                    type="text"

                                    label="startModulus"
                                    style={{ width: '100%', height: '49px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                    className={`form-control`}

                                    name="startModulus"
                                    value={moduleDetailsMap[editFormData.startModulus]} // Default value is set to '2000-01-01'
                                    onChange={handleChange}
                                /> */}
                                <TextField
                                    fullWidth
                                    label="Start Modulus"
                                    name="startModulus"
                                    value={moduleDetailsMap[editFormData.startModulus] || ''}
                                    // value={editFormData.startModulus}

                                    // onChange={handleDateChange}
                                    InputProps={{ readOnly: true }} // Make this field read-only
                                    InputLabelProps={{ shrink: true }} // Force label to shrink
                                />
                            </div>
                        </Grid>

                        {/* <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Start Module"
                                name="startModulus"
                                value={moduleDetailsMap[formData.startModulus]}
                                onChange={handleDateChange}
                                InputProps={{ readOnly: true }} // Make this field read-only
                                InputLabelProps={{ shrink: true }} // Force label to shrink
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                label="Enrollment Date"
                                name="enrolledDate"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={formData.enrolledDate}
                                onChange={handleDateChange}
                            />
                        </Grid> */}


                        <Grid item xs={12} sm={6}>

                            <TextField
                                label="Password*"
                                name="password"
                                value={editFormData.password}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>

                            <TextField
                                label="Religion*"
                                name="religion"
                                value={editFormData.religion}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>

                            <TextField
                                label="Citizenship*"
                                name="citizenship"
                                value={editFormData.citizenship}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>

                            <TextField
                                label="Home Address*"
                                name="address"
                                value={editFormData.address}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>

                            <TextField
                                label="Singapore Address*"
                                name="currentAddress"
                                value={editFormData.currentAddress}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>

                            <TextField
                                label="Relationship*"
                                name="relationship"
                                value={editFormData.relationship}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>

                            <TextField
                                label="Emergency Contact Name*"
                                name="fatherName"
                                value={editFormData.fatherName}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                type='number'
                                label="Emergency Contact Number*"
                                name="fatherPhoneNo"
                                value={editFormData.fatherPhoneNo}
                                onChange={handleChange}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                }}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>

                        {/* <Grid item xs={12} sm={6}>

                            <TextField
                                label="Brother Name*"
                                name="brotherName"
                                value={editFormData.brotherName}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                type='number'
                                label="Brother PhoneNo*"
                                name="brotherPhoneNo"
                                value={editFormData.brotherPhoneNo}
                                onChange={handleChange}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                }}
                                fullWidth
                                margin="normal"
                            />
                        </Grid> */}

                        <Grid container >
                            <Grid item xs={12} md={6} sx={{ paddingLeft: 4, paddingRight: 2 }}>
                                {/* <Typography variant="contained" gutterBottom> */}
                                <Button
                                    type="button"
                                    style={{
                                        margin: '10px 0',
                                        // padding: '10px 20px',
                                        fontSize: '16px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        borderRadius: '8px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                        // boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                    onClick={handleAddEducation}
                                >
                                    + Add Education
                                </Button>
                                <br /><br />
                                {editFormData.institutionDetails && (
                                    editFormData.institutionDetails.map((institution, index) => (
                                        <Box
                                            key={index}
                                            mb={4}
                                            sx={{
                                                border: '1px solid #ccc',
                                                borderRadius: '12px',
                                                padding: 2,
                                                boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
                                                backgroundColor: '#fafafa',
                                            }}
                                        >
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="Institution Name"
                                                        name="institution"
                                                        value={institution.institution}
                                                        onChange={(e) => handleInstitutionChange(index, e)}
                                                        variant="outlined"
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="Degree"
                                                        name="qualificationsAchieved"
                                                        value={institution.qualificationsAchieved}
                                                        onChange={(e) => handleInstitutionChange(index, e)}
                                                        variant="outlined"
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="Country"
                                                        name="country"
                                                        value={institution.country}
                                                        onChange={(e) => handleInstitutionChange(index, e)}
                                                        variant="outlined"

                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="Certificate Number"
                                                        name="educationCertificateNo"
                                                        value={institution.educationCertificateNo}
                                                        onChange={(e) => handleInstitutionChange(index, e)}
                                                        variant="outlined"

                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="From Year"
                                                        name="fromYear"
                                                        value={institution.fromYear}
                                                        onChange={(e) => handleInstitutionChange(index, e)}
                                                        variant="outlined"
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="To Year"
                                                        name="toYear"
                                                        value={institution.toYear}
                                                        onChange={(e) => handleInstitutionChange(index, e)}
                                                        variant="outlined"
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Button
                                                        type="button"
                                                        onClick={() => handleRemoveEducation(index)}
                                                        variant="contained"
                                                        color="error"
                                                        sx={{ borderRadius: 2, mt: 1 }}
                                                    >
                                                        Remove
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    ))
                                )}
                            </Grid>



                            <Grid item xs={12} md={6} >
                                <Typography variant="outlined" gutterBottom>
                                    <Button
                                        type="button"
                                        onClick={handleAddWorkExperience}
                                        style={{
                                            margin: '10px 0',
                                            // padding: '10px 20px',
                                            fontSize: '16px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            borderRadius: '8px',
                                            border: 'none',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.3s ease',
                                            // boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                        }}
                                    >
                                        + Add Employment

                                    </Button>
                                </Typography>
                                {/* </Grid>
                    <Grid item xs={12} sm={6}> */}
                                <br />
                                <br />
                                {editFormData.workExpirences && (
                                    editFormData.workExpirences.map((experience, index) => (
                                        <Box
                                            key={index}
                                            mb={4}
                                            sx={{
                                                border: '1px solid #ccc',
                                                borderRadius: '12px',
                                                padding: 2,
                                                boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
                                                backgroundColor: '#fafafa',
                                            }}
                                        >
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={12}>
                                                    <TextField
                                                        fullWidth
                                                        label="Company Name"
                                                        name="name"
                                                        value={experience.name}
                                                        onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        variant="outlined"
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="Nature of Duties"
                                                        name="position"
                                                        value={experience.position}
                                                        onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        variant="outlined"
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="Country"
                                                        name="country"
                                                        value={experience.country}
                                                        onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        variant="outlined"

                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="From Year"
                                                        name="fromYear"
                                                        value={experience.fromYear}
                                                        onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        variant="outlined"
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <TextField
                                                        fullWidth
                                                        label="To Year"
                                                        name="toYear"
                                                        value={experience.toYear}
                                                        onChange={(e) => handleWorkExperienceChange(index, e)}
                                                        variant="outlined"
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Button
                                                        type="button"
                                                        onClick={() => handleRemoveWorkExperience(index)}
                                                        variant="contained"
                                                        color="error"
                                                        sx={{ borderRadius: 2, mt: 1 }}
                                                    >
                                                        Remove
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    ))
                                )}
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} >
                            <Grid item sm={12} md={6}>
                                <Paper elevation={2} style={{ padding: '16px', borderRadius: '8px' }}>
                                    <Typography variant="subtitle1" style={{ marginBottom: '8px', fontWeight: 600 }}>
                                        Upload photo
                                    </Typography>
                                    <input
                                        type="file"
                                        name="profile"
                                        accept="image/png, image/jpeg, image/jpg"
                                        onChange={(event) => {
                                            const file = event.target.files[0];
                                            if (!file) return;

                                            if (file.size > 8 * 1024 * 1024) {
                                                event.target.value = "";
                                                toast.error("Max file size 8MB");
                                                return;
                                            }

                                            const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
                                            if (!allowedTypes.includes(file.type)) {
                                                event.target.value = "";
                                                toast.error("Only PNG, JPG, JPEG allowed");
                                                return;
                                            }

                                            handleFileChange(event);
                                        }}
                                        className="form-control"
                                        style={{ width: '100%', borderRadius: '4px', border: '1px solid #ccc' }}
                                    />
                                    {uploadedPreviews.profileUrl && (
                                        <div style={{ marginTop: '16px' }}>
                                            <Typography variant="body2" style={{ marginBottom: '4px' }}>
                                                Preview:
                                            </Typography>
                                            <img
                                                src={uploadedPreviews.profileUrl}
                                                alt="Profile Preview"
                                                style={{ maxWidth: '100%', maxHeight: '80px', borderRadius: '4px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)' }}
                                            />
                                        </div>
                                    )}
                                </Paper>
                                <br />
                            </Grid>

                            <Grid item sm={12} md={6}>
                                <Paper elevation={2} style={{ padding: '16px', borderRadius: '8px' }}>
                                    <Typography variant="subtitle1" style={{ marginBottom: '8px', fontWeight: 600 }}>
                                        NRIC Document
                                    </Typography>
                                    <input
                                        type="file"
                                        name="nric"
                                        accept="application/pdf"
                                        onChange={(event) => {
                                            const file = event.target.files[0];
                                            if (!file) return;

                                            if (file.size > 8 * 1024 * 1024) {
                                                event.target.value = ""; // Reset file input
                                                toast.error("Max file size 8MB");
                                                return;
                                            }

                                            if (file.type !== "application/pdf") {
                                                event.target.value = "";
                                                toast.error("Only PDF allowed");
                                                return;
                                            }

                                            handleFileChange(event);
                                        }}
                                        className="form-control"
                                        style={{ width: '100%', borderRadius: '4px', border: '1px solid #ccc' }}
                                    />
                                    {uploadedPreviews.nricdoc && (
                                        <div style={{ marginTop: '16px' }}>
                                            <Typography variant="body2" style={{ marginBottom: '4px' }}>
                                                Preview:
                                            </Typography>
                                            <img
                                                src={uploadedPreviews.nricdoc}
                                                alt="NRIC Document"
                                                style={{ maxWidth: '100%', maxHeight: '80px', borderRadius: '4px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)' }}
                                            />
                                        </div>
                                    )}
                                </Paper>
                            </Grid>
                        </Grid>


                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <Paper elevation={2} style={{ padding: '16px', borderRadius: '8px' }}>
                                    <Typography variant="subtitle1" style={{ marginBottom: '8px', fontWeight: 600 }}>
                                        Educational Document
                                    </Typography>
                                    <input
                                        type="file"
                                        name="educational"
                                        accept="application/pdf"
                                        onChange={(event) => {
                                            const file = event.target.files[0];
                                            if (!file) return;

                                            if (file.size > 8 * 1024 * 1024) {
                                                event.target.value = ""; // Reset file input
                                                toast.error("Max file size 8MB");
                                                return;
                                            }

                                            if (file.type !== "application/pdf") {
                                                event.target.value = "";
                                                toast.error("Only PDF allowed");
                                                return;
                                            }

                                            handleFileChange(event);
                                        }}
                                        className="form-control"
                                        style={{ width: '100%', borderRadius: '4px', border: '1px solid #ccc', padding: '8px' }}
                                    />
                                    {uploadedPreviews.educationdoc && (
                                        <div style={{ marginTop: '16px' }}>
                                            <Typography variant="body2" style={{ marginBottom: '4px' }}>
                                                Preview:
                                            </Typography>
                                            <img
                                                src={uploadedPreviews.educationdoc}
                                                alt="Educational Document"
                                                style={{ maxWidth: '100%', maxHeight: '80px', borderRadius: '4px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)' }}
                                            />
                                        </div>
                                    )}
                                </Paper>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Paper elevation={2} style={{ padding: '16px', borderRadius: '8px' }}>
                                    <Typography variant="subtitle1" style={{ marginBottom: '8px', fontWeight: 600 }}>
                                        Passport Document
                                    </Typography>
                                    <input
                                        type="file"
                                        name="passport"
                                        accept="application/pdf"
                                        onChange={(event) => {
                                            const file = event.target.files[0];
                                            if (!file) return;

                                            if (file.size > 8 * 1024 * 1024) {
                                                event.target.value = ""; // Reset file input
                                                toast.error("Max file size 8MB");
                                                return;
                                            }

                                            if (file.type !== "application/pdf") {
                                                event.target.value = "";
                                                toast.error("Only PDF allowed");
                                                return;
                                            }

                                            handleFileChange(event);
                                        }}

                                        className="form-control"
                                        style={{ width: '100%', borderRadius: '4px', border: '1px solid #ccc', padding: '8px' }}
                                    />
                                    {uploadedPreviews.passportdoc && (
                                        <div style={{ marginTop: '16px' }}>
                                            <Typography variant="body2" style={{ marginBottom: '4px' }}>
                                                Preview:
                                            </Typography>
                                            <img
                                                src={uploadedPreviews.passportdoc}
                                                alt="Passport Document"
                                                style={{ maxWidth: '100%', maxHeight: '80px', borderRadius: '4px', boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)' }}
                                            />
                                        </div>
                                    )}
                                </Paper>
                            </Grid>
                        </Grid>

                    </Grid>
                    <br />
                    <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={handleSaveEdit} variant="contained" color="primary" style={{ backgroundColor: 'green', color: 'white' }}>
                            Update
                        </Button>
                    </Grid>
                </form>
            </Paper>

            <ToastContainer />
        </Container >
    );
};

export default ViewDetailsModal;
